import { render, staticRenderFns } from "./PersonalityTest.vue?vue&type=template&id=a1ac2574&scoped=true"
import script from "./PersonalityTest.vue?vue&type=script&lang=js"
export * from "./PersonalityTest.vue?vue&type=script&lang=js"
import style0 from "./PersonalityTest.vue?vue&type=style&index=0&id=a1ac2574&prod&lang=scss&scoped=true"
import style1 from "./PersonalityTest.vue?vue&type=style&index=1&id=a1ac2574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ac2574",
  null
  
)

export default component.exports